<template>
  <!-- 登录页面 -->
  <div>
    <Row class="container">
      <i-col span="13" offset="2" class="login-img-box"> </i-col>
      <i-col span="7" class="login-box">
        <div class="login-container">
          <div class="login-header">
            <p>欢迎登录</p>
          </div>
          <div class="form-box">
            <Form ref="formInline" :model="formDate" :rules="ruleInline">
              <FormItem prop="account">
                <i-input
                  type="text"
                  v-model="formDate.account"
                  clearable
                  size="large"
                  placeholder="用户名"
                >
                  <Icon type="person" slot="prepend"></Icon>
                </i-input>
              </FormItem>
              <FormItem prop="password">
                <i-input
                  type="password"
                  v-model="formDate.password"
                  clearable
                  size="large"
                  placeholder="密码"
                >
                  <Icon type="ios-locked-outline" slot="prepend"> </Icon>
                </i-input>
              </FormItem>
              <FormItem>
                <Button
                  type="error"
                  size="large"
                  @click="handleSubmit('formInline')"
                  long
                  >登录</Button
                >
              </FormItem>
            </Form>
            <div class="forget-box">
              <div>
                <router-link to="/retrievePassword">
                  忘记密码？
                </router-link>
              </div>
              <div>
                <router-link to="/SignUp">
                  <Icon type="log-in"></Icon><span class="now">立即注册</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </i-col>
    </Row>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { login, getUserInfo } from "@api/user";
export default {
  name: "Login",
  data() {
    return {
      formDate: {
        account: "",
        password: ""
      },
      ruleInline: {
        account: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            type: "string",
            min: 6,
            message: "密码不能少于6位",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    ...mapMutations(["SET_USER_TOKEN", "SET_USER_INFO", "SIGN_OUT"]),
    handleSubmit(name) {
      const father = this;
      this.$refs[name].validate(valid => {
        if (valid) {
          login(father.formDate)
            .then(result => {
              if (result && result.status === 200) {
                // 储存用户token
                this.SET_USER_TOKEN(result.data.token);
                sessionStorage.setItem("is_login", 1);
                sessionStorage.setItem("token", result.data.token);
                getUserInfo()
                  .then(res => {
                    // 储存用户信息
                    this.SET_USER_INFO(res.data);
                    sessionStorage.setItem(
                      "userInfo",
                      JSON.stringify(res.data)
                    );
                    this.$Message.success("登录成功");
                    const backUrl = localStorage.getItem("login_back_url");
                    if (backUrl) {
                      if (backUrl === "/register") {
                        father.$router.push({
                          path: "/"
                        });
                      } else {
                        father.$router.push(backUrl);
                      }
                    } else {
                      father.$router.push({
                        path: "/"
                      });
                    }
                    localStorage.removeItem("login_back_url");
                  })
                  .catch(err => {
                    this.$Message.error(err.msg);
                  });
              } else {
                this.$Message.error("用户名或密码错误");
              }
            })
            .catch(err => {
              this.$Message.error(err.msg);
            });
        } else {
          this.$Message.error("请填写正确的用户名或密码");
        }
      });
    }
  }
};
</script>

<style scoped>
.container {
  margin-bottom: -30px;
  background-color: #fff;
  background-image: url("../../assets/pc/images/home/login.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.login-img-box {
  height: 380px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-img-box > img {
  width: 68%;
}
.login-box {
  height: 380px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-container {
  width: 80%;
  height: 300px;
  background: #fff;
  border-radius: 3%;
}
.login-header {
  height: 60px;
  font-size: 20px;
  text-align: left;
  line-height: 60px;
  letter-spacing: 2px;
  color: #333;
  margin-left: 30px;
  margin-top: 10px;
}
.form-box {
  width: 80%;
  margin: 0 auto;
}
.forget-box {
  margin-top: -10px;
}
.forget-box div:first-child {
  color: #848484;
}
.forget-box div:last-child {
  text-align: right;
  color: #f60000;
}
.forget-box div .now {
  margin-left: 5px;
}
</style>
